<app-dialog (close)="close()" [title]="data.title">
    <ng-container dialogContent>
        <ng-container *ngIf="isLoad">
            <div class="history-links-container">
                <ng-container
                    *ngIf="!historyData?.histories || (historyData?.histories && historyData?.histories.length === 0)"
                >
                    {{ appService.language_dictionary.factor_data_not_changed }}
                </ng-container>
                <ng-container *ngIf="historyData?.histories && historyData?.histories.length">
                    <div class="history-links-header" fxLayout="row" fxLayoutAlign="flex-start">
                        <div *ngIf="historyData?.column?.is_date" class="history-link-header" fxFlex="0 1 11%">
                            <b>{{ appService.language_dictionary.system_date }}</b>
                        </div>
                        <div *ngIf="historyData?.column?.is_factor_name" class="history-link-header" fxFlex="0 1 12%">
                            <b>{{ appService.language_dictionary.system_name }}</b>
                        </div>
                        <div *ngIf="historyData?.column?.is_type" class="history-link-header" fxFlex="0 1 15%">
                            <b>{{ appService.language_dictionary.factor_type }}</b>
                        </div>
                        <div *ngIf="historyData?.column?.is_value" class="history-link-header" fxFlex="0 1 31%">
                            <b>{{ appService.language_dictionary.factor_old_values }}</b>
                        </div>
                        <div *ngIf="historyData?.column?.is_current_value" class="history-link-header" fxFlex="0 1 31%">
                            <b>{{ appService.language_dictionary.factor_current_values }}</b>
                        </div>
                        <div *ngIf="historyData?.column?.is_fio" class="history-link-header" fxFlex="0 1 15%">
                            <b>{{ appService.language_dictionary.factor_full_name }}</b>
                        </div>
                    </div>
                    <ng-container *ngFor="let record of historyData.histories">
                        <div class="history-links-row" fxLayout="row" fxLayoutAlign="flex-start">
                            <div
                                *ngIf="historyData?.column?.is_date"
                                class="history-links-column"
                                fxFlex="0 1 11%"
                                class="history-links-column"
                            >
                                {{ record.date }}
                            </div>
                            <div
                                *ngIf="historyData?.column?.is_factor_name"
                                class="history-links-column"
                                fxFlex="0 1 12%"
                            >
                                {{ record.factor_name }}
                            </div>
                            <div
                                *ngIf="historyData?.column?.is_type"
                                class="history-links-column"
                                fxFlex="0 1 15%"
                                class="history-links-column"
                            >
                                {{ record.type }}
                            </div>
                            <div
                                *ngIf="historyData?.column?.is_value"
                                [innerHTML]="record.value"
                                [title]="record.value?.length > 260 ? stripHtml(record.value) : ''"
                                class="history-links-column web-kit-box"
                                fxFlex="0 1 31%"
                            ></div>
                            <div
                                *ngIf="historyData?.column?.is_current_value"
                                [innerHTML]="record.current_value"
                                [title]="record.current_value?.length > 260 ? stripHtml(record.current_value) : ''"
                                class="history-links-column web-kit-box"
                                fxFlex="0 1 31%"
                            ></div>
                            <div
                                *ngIf="historyData?.column?.is_fio"
                                class="history-links-column"
                                fxFlex="0 1 15%"
                                class="history-links-column"
                            >
                                {{ record.fio }}
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
    <ng-container dialogActions>
        <ng-container *ngIf="historyData?.all_history && historyData?.histories.length">
            <fui-button
                (clickEvent)="
                    factorRowHistoryService.exportChangeHistory(spinner, notifier, {
                        factor_data_id: data.data.factor_data_id,
                        factor_id: data.data.factor_id,
                        language: data.data.language,
                    })
                "
                [label]="appService.language_dictionary.report_download_to_excel"
                height="mini"
                icon="file-export-outline"
            >
            </fui-button>
        </ng-container>
        <fui-button
            (clickEvent)="close()"
            [label]="appService.language_dictionary.system_close"
            color="light"
            height="mini"
            icon="close"
        >
        </fui-button>
    </ng-container>
</app-dialog>
